import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { toast } from '@liveauctioneers/hammer-ui-core/toast';
import queryString from 'query-string';
import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAppSelector } from '@/redux/hooks';
import { getEmailLists } from '@/redux/modules/account/notifications/emailList/emailList.selectors';
import { UNSUBSCRIBE_TO_ALL_EMAIL_LISTS } from '@/redux/modules/account/notifications/emailList/emailList.types';
import { useToggleEmailListSubscription } from '@/redux/modules/account/notifications/emailList/useToggleEmailListSubscription';
import { getBidderEmail } from '@/redux/modules/account/user/user.selectors';

const UnsubscribeEmail = () => {
    const toggleSubscription = useToggleEmailListSubscription();
    const { formatMessage } = useIntl();
    const emailList = useAppSelector(getEmailLists);
    const { search } = useLocation();
    const navigate = useNavigate();
    const userEmail = useAppSelector(getBidderEmail);
    const queryParams = queryString.parse(search);
    const { unsubscribe: unsubscribeParam = '' } = queryParams;

    React.useEffect(() => {
        if (!unsubscribeParam || !userEmail || !emailList.length) {
            return;
        }
        const emailSelection: any = emailList.find(({ code }) => code === unsubscribeParam);

        if (unsubscribeParam === UNSUBSCRIBE_TO_ALL_EMAIL_LISTS) {
            // handle the case that they want to unsubscribe to everything
            toggleSubscription({ code: unsubscribeParam }).then(
                (saved) =>
                    saved &&
                    toast('success', {
                        description: formatMessage(
                            {
                                id: 'toastMessages.descriptions.unsubscribeAllEmailPreference',
                            },
                            { email: `${userEmail}` }
                        ),
                        title: formatMessage({
                            id: 'toastMessages.titles.success',
                        }),
                    })
            );
        } else if (emailSelection?.subscribed) {
            toggleSubscription({ code: emailSelection.code }).then(
                (saved) =>
                    saved &&
                    toast('success', {
                        description: formatMessage(
                            {
                                id: 'toastMessages.descriptions.unsubscribeEmailPreference',
                            },
                            {
                                alert: `${emailSelection.name}`,
                                email: `${userEmail}`,
                            }
                        ),
                        title: formatMessage({
                            id: 'toastMessages.titles.success',
                        }),
                    })
            );
        } else if (!emailSelection?.name) {
            // handle unrecognized subscriptions codes
            toast('error', {
                description: formatMessage({
                    id: 'toastMessages.descriptions.unsubscribeEmailDontRecognize',
                }),
                title: formatMessage({
                    id: 'toastMessages.titles.success',
                }),
            });
        }

        navigate({});
    }, [toggleSubscription, emailList, userEmail, unsubscribeParam, navigate, formatMessage]);

    return null;
};

export default UnsubscribeEmail;
